import {
	FETCH_NOTIF_ELIGIBILITE_BEGIN,
	FETCH_NOTIF_ELIGIBILITE_SUCCESS,
	FETCH_NOTIF_ELIGIBILITE_ERROR,
	PUT_NOTIF_ELIGIBILITE_BEGIN,
	PUT_NOTIF_ELIGIBILITE_SUCCESS,
	PUT_NOTIF_ELIGIBILITE_ERROR,
	PUT_NOTIF_ELIGIBILITE_RESET,
} from "../actions/notificationEligibiliteActions"

// `categories` : [{cle, label, cycle, vocal, groupes}] — le cycle et le drapeau
// vocal viennent du registre (code, non éditable), seuls les `groupes` sont
// modifiables. `groupes` (racine) : tous les groupes Django existants = les
// colonnes de la matrice.
const initialState = {
	categories: [],
	groupes: [],
	fetchEligibilite: { loading: false, error: false },
	putEligibilite: { saving: false, saved: false, error: false },
}

export default function notificationEligibiliteReducer(
	state = initialState,
	action,
) {
	switch (action.type) {
		case FETCH_NOTIF_ELIGIBILITE_BEGIN:
			return {
				...state,
				fetchEligibilite: { loading: true, error: false },
			}
		case FETCH_NOTIF_ELIGIBILITE_SUCCESS:
			return {
				...state,
				categories: action.payload.categories || [],
				groupes: action.payload.groupes || [],
				fetchEligibilite: { loading: false, error: false },
			}
		case FETCH_NOTIF_ELIGIBILITE_ERROR:
			return {
				...state,
				fetchEligibilite: { loading: false, error: action.payload },
			}
		case PUT_NOTIF_ELIGIBILITE_BEGIN:
			return {
				...state,
				putEligibilite: { saving: true, saved: false, error: false },
			}
		case PUT_NOTIF_ELIGIBILITE_SUCCESS:
			// Le PUT renvoie l'état à jour : on remplace, pas de refetch.
			return {
				...state,
				categories: action.payload.categories || [],
				groupes: action.payload.groupes || [],
				putEligibilite: { saving: false, saved: true, error: false },
			}
		case PUT_NOTIF_ELIGIBILITE_ERROR:
			return {
				...state,
				putEligibilite: {
					saving: false,
					saved: false,
					error: action.payload,
				},
			}
		case PUT_NOTIF_ELIGIBILITE_RESET:
			return {
				...state,
				putEligibilite: { saving: false, saved: false, error: false },
			}
		default:
			return state
	}
}
